/* oxlint-disable typescript/consistent-type-assertions -- lint to the future batch ignore */
import type { ComponentPropsWithoutRef, ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { GOOGLE_PLAY_BADGE_ASSETS } from 'register-partners-js/constants/store-badge-assets';

type PlayStoreBadgeProps = ComponentPropsWithoutRef<'a'>;

export function PlayStoreBadge(props: PlayStoreBadgeProps): ReactElement {
  const { locale } = useIntl();

  const badgeUrl = `https://play.google.com/store/apps/details?id=eu.qonto.qonto&hl=${locale}`;
  const badgeSrc = GOOGLE_PLAY_BADGE_ASSETS[locale as keyof typeof GOOGLE_PLAY_BADGE_ASSETS];

  return (
    <a href={badgeUrl} {...props}>
      <img alt="" src={badgeSrc} />
    </a>
  );
}
